import { render } from "./AdminsPanel.vue?vue&type=template&id=599b0f42&scoped=true"
import script from "./AdminsPanel.vue?vue&type=script&lang=js"
export * from "./AdminsPanel.vue?vue&type=script&lang=js"

import "./AdminsPanel.vue?vue&type=style&index=0&id=599b0f42&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599b0f42"]])

export default __exports__